import { useSyncExternalStore } from "react"

const state: Record<string, number> = {}
const listeners = new Set<()=> void>()

export function setSpeedReaderProgress(bookIndex: string, value: number) {
  if (state[bookIndex] === value) return
  state[bookIndex] = value
  for (const listener of listeners) {
    listener()
  }
}

export function useSpeedReaderProgress(bookIndex: string) {
  return useSyncExternalStore(
    subscribe,
    ()=> getSnapshot(bookIndex),
    ()=> getSnapshot(bookIndex),
  )
}

function getSnapshot(bookIndex: string) {
  return state[bookIndex] ?? 0
}

function subscribe(listener: ()=> void) {
  listeners.add(listener)
  return ()=> {
    listeners.delete(listener)
  }
}
